import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconWifiWarning$1 = /*@__PURE__*/ proxyCustomElement(class WppIconWifiWarning extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-wifi-warning", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M14.7408 8.83929C14.8206 8.91908 14.8986 9.00171 14.9746 9.08687C14.4702 8.97936 13.9302 9.06266 13.4809 9.3368C11.3921 7.63 8.30842 7.75069 6.36023 9.69888C5.95679 10.1023 5.62904 10.556 5.37671 11.0548C5.22519 11.3544 4.85953 11.4744 4.55998 11.3229C4.26043 11.1714 4.14042 10.8057 4.29194 10.5061C4.60217 9.8928 5.0058 9.33413 5.50064 8.83929C8.05223 6.2877 12.1892 6.2877 14.7408 8.83929ZM10.0505 15.5244L11.0361 13.5518C11.0078 13.5164 10.9773 13.4822 10.9445 13.4494C10.4697 12.9746 9.69987 12.9746 9.22507 13.4494C8.75028 13.9242 8.75028 14.694 9.22507 15.1688C9.45376 15.3975 9.75089 15.516 10.0505 15.5244ZM11.8571 11.9084L12.4066 10.8086C10.8033 9.73878 8.61638 9.91137 7.20139 11.3264C6.8392 11.6886 6.55037 12.1218 6.34173 12.5987C6.20716 12.9062 6.34738 13.2646 6.65492 13.3992C6.96246 13.5337 7.32086 13.3935 7.45542 13.086C7.60501 12.7441 7.80933 12.4376 8.06098 12.186C9.09622 11.1507 10.7172 11.0582 11.8571 11.9084ZM16.9315 6.836C17.344 7.24854 17.7335 7.71987 18.0726 8.2112C18.2633 8.48748 18.1939 8.86602 17.9177 9.0567C17.6414 9.24738 17.2628 9.17799 17.0722 8.90171C16.7739 8.46958 16.4312 8.05492 16.0719 7.69559C12.7653 4.38899 7.40425 4.38899 4.09765 7.69559C3.75575 8.03749 3.41666 8.45212 3.10729 8.89807C2.91594 9.17389 2.53723 9.24237 2.26142 9.05102C1.9856 8.85968 1.91712 8.48097 2.10846 8.20515C2.45708 7.70263 2.84156 7.23251 3.23806 6.836C7.01939 3.05467 13.1501 3.05467 16.9315 6.836ZM13.4544 10.5246L10.2151 17.0066C9.81099 17.8153 10.3992 18.7666 11.3034 18.7666H17.7818C18.6861 18.7666 19.2743 17.8153 18.8702 17.0066L15.631 10.5246C15.1828 9.62763 13.9026 9.62762 13.4544 10.5246ZM14.9482 12.6848V15.1175C14.9482 15.3414 14.7666 15.5229 14.5427 15.5229C14.3187 15.5229 14.1371 15.3414 14.1371 15.1175V12.6848C14.1371 12.4609 14.3187 12.2794 14.5427 12.2794C14.7666 12.2794 14.9482 12.4609 14.9482 12.6848ZM14.5427 17.1447C14.3187 17.1447 14.1371 16.9632 14.1371 16.7393C14.1371 16.5154 14.3187 16.3338 14.5427 16.3338C14.7666 16.3338 14.9482 16.5154 14.9482 16.7393C14.9482 16.9632 14.7666 17.1447 14.5427 17.1447Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-wifi-warning-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-wifi-warning", "wpp-icon-wifi-warning-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-wifi-warning-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-wifi-warning-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconWifiWarning$1);
      }
      break;
  } });
}

const WppIconWifiWarning = WppIconWifiWarning$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconWifiWarning, defineCustomElement };
